import { render, staticRenderFns } from "./CollectionsList.vue?vue&type=template&id=6ad5dcb4&scoped=true"
import script from "./CollectionsList.vue?vue&type=script&lang=js"
export * from "./CollectionsList.vue?vue&type=script&lang=js"
import style0 from "./CollectionsList.vue?vue&type=style&index=0&id=6ad5dcb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad5dcb4",
  null
  
)

export default component.exports